export default function ({ $axios }, inject) {
  // Create a custom axios instance
  const api = $axios.create({
    headers: {
      // headers you need
    }
  });
  // Inject to context as $api
  inject('api', api);
}
